// localStorage.js
export const loadState = () => {
  try {
    //const serializedState = localStorage.getItem('reduxState');
    const serializedState = sessionStorage.getItem("reduxState");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error("Error loading state from sessionStorage:", err);
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    //localStorage.setItem('reduxState', serializedState);
    sessionStorage.setItem("reduxState", serializedState);
  } catch (err) {
    console.error("Error saving state to sessionStorage:", err);
  }
};
